import LoginFooter from '@features/common/footer/loginFooter/LoginFooter'
import Notifier from '@features/common/notifier/Notifier'
import { Outlet } from 'react-router-dom'
import styles from './CorporateLayout.module.scss'

const CorporateLayout = () => {
  return (
    <div className={styles["corporate-layout"]} style={{
        backgroundImage: `url(/images/login-bg-image.png)`,
      }}>
        <Notifier />
        <Outlet />
        <LoginFooter/>
    </div>
  )
}

export default CorporateLayout